module.exports = __webpack_public_path__ + "static/media/logo-onogate-ori.cce7d248.png";